<script setup>
import TvTable from '~/components/tv/TvTable.vue';

// The club's most wins (realtime stats, top ten with at least one match)
const props = defineProps({
  panel: {type: Object, required: true},
});
// wide, column or portrait (set by the panel's frame)
const mode = inject('tvMode', ref('wide'));

const rows = computed(() => (props.panel.stats?.rows ?? []).slice(0, 9)
    .map(r => ({...r, pct: `${Math.round(r.winPercentage)}%`})));
const hasDraws = computed(() => rows.value.some(r => r.draws));

const columns = computed(() => {
  const narrow = mode.value !== 'wide';
  return [
    {key: 'position', label: '', width: narrow ? '84px' : '110px'},
    {key: 'playerName', label: 'Player'},
    ...(narrow ? [] : [{key: 'played', label: 'Played', num: true, width: '160px'}]),
    {key: 'wins', label: narrow ? 'W' : 'Won', num: true, strong: true, width: narrow ? '84px' : '140px'},
    ...(hasDraws.value ? [{key: 'draws', label: narrow ? 'D' : 'Drawn', num: true, width: narrow ? '84px' : '140px'}] : []),
    {key: 'losses', label: narrow ? 'L' : 'Lost', num: true, width: narrow ? '84px' : '140px'},
    {key: 'pct', label: narrow ? 'Win %' : 'Win rate', num: true, width: narrow ? '150px' : '190px'},
  ];
});
</script>

<template>
  <tv-table :columns="columns" :rows="rows" :row-key="r => r.position + r.playerName" :lead="Math.min(3, rows.length)"/>
</template>
